<template>
	<div class="grn-details">
		<v-row>
			<v-col cols="8">
				<h1 class="text-left mx-4">GRN : {{ grn.GRN_number }}</h1>
			</v-col>
			<v-col cols="4" class="text-right">
				<v-btn
					color="red"
					class="my-2 mr-8"
					dense
					small
					v-if="currentUser.privileges.canDeleteGRNs"
					@click="showDeleteDialog"
					rounded
					outlined
					>Delete</v-btn
				>
			</v-col>
		</v-row>

		<v-container class="mx-2 my-0">
			<v-row>
				<v-col cols="6" md="4">
					<h3 class="text-left">
						<router-link
							:to="{
								name: 'PurchaseOrderDetails',
								params: { po_id: grn.purchase_order.id },
							}"
						>
							<span>{{ grn.purchase_order.order_number }}</span>
						</router-link>
					</h3>
					<!-- <h3 class="text-left">{{ grn.purchase_order.order_number }}</h3> -->
					<p class="mb-0 text-left">Purchase Order</p>
				</v-col>
				<v-col cols="6" md="4">
					<h3 class="text-left">{{ grn.invoice_number }}</h3>
					<p class="mb-0 text-left">Invoice Number</p>
				</v-col>
				<v-col cols="6" md="4">
					<h3 class="text-left">
						{{ moment(grn.created).format("h:mma, D MMMM, YYYY") }}
					</h3>
					<p class="mb-0 text-left">GRN Created Time</p>
				</v-col>
				<v-col cols="6" md="4">
					<h3 class="text-left">
						{{
							grn.invoice_date
								? moment(grn.invoice_date).format("D MMMM, YYYY")
								: "-"
						}}
					</h3>
					<p class="mb-0 text-left">Invoice Date</p>
				</v-col>
				<v-col cols="6" md="4">
					<h3 class="text-left">{{ currencyFormat(grn.other_charges) }}</h3>
					<p class="mb-0 text-left">Other Charges</p>
				</v-col>
				<v-col cols="6" md="4">
					<h3 class="text-left">{{ grn.batch_number }}</h3>
					<p class="mb-0 text-left">Batch Number</p>
				</v-col>
				<v-col cols="12" md="12">
					<h3 class="mb-0 text-left">Notes</h3>
					<p class="text-left">{{ grn.notes || "-" }}</p>
				</v-col>
			</v-row>
			<v-btn
				color="primary"
				outlined
				v-if="grn.document"
				:href="grn.document"
				target="_blank"
			>
				<span class="mx-2"> Download Invoice </span>
				<v-icon>mdi-cloud-download</v-icon>
			</v-btn>
		</v-container>
		<DeleteConfirmationDialog
			title="Are you sure you want to delete this GRN?"
			description="Deleting this GRN will change the associated Purchase Order status to 'Pending'"
			:visible="showDeleteConfirmation"
			@deleteObject="deleteObjectConfirmation"
		/>

		<v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template>
				<v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
	import api from "@api/index";
	import { mapActions, mapGetters } from "vuex";
	import endpoints from "@api/repository";
	import moment from "moment";
	import Helper from "@utils/misc";
	import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";

	export default {
		name: "PurchaseOrderDetails",
		components: {
			DeleteConfirmationDialog,
		},
		data() {
			return {
				moment: moment,
				snackbar: {
					visible: false,
					text: "",
				},
				grn: {
					id: null,
					GRN_number: null,
					purchase_order: {
						id: null,
						order_number: null,
					},
					invoice_number: null,
					created: null,
					invoice_date: null,
					invoice_file: null,
					other_charges: 0,
					notes: null,
				},
				showDeleteConfirmation: false,
			};
		},
		computed: {
			...mapGetters(["currentUser", "accessToken", "isLoading"]),
			essentials() {
				return {
					accessToken: this.accessToken,
					setLoading: this.setLoading,
					handleErrorsFunction: this.handleApiErrors,
				};
			},
		},
		methods: {
			...mapActions(["setLoading"]),

			async getGrnDetails() {
				var url = endpoints.grns + this.$route.params.grn_id + "/";
				this.grn = await api.call(this.essentials, url);
			},

			async showDeleteDialog() {
				this.showDeleteConfirmation = true;
			},

			async deleteObjectConfirmation(confirm) {
				this.showDeleteConfirmation = false;
				var url = endpoints.grns + this.$route.params.grn_id + "/";
				if (confirm) {
					var response;
					response = await api.handleApi({
						apiEssentials: this.essentials,
						url: url,
						method: api.Methods.DELETE,
						responseVar: response,
					});
					if (response) {
						this.$router.push({
							name: "PurchaseOrderDetails",
							params: { po_id: this.grn.purchase_order.id },
						});
					}
				}
			},

			// handles api errors
			async handleApiErrors(err) {
				this.setLoading(false);
				if (err.response) {
					console.log(err.response);
				} else {
					this.snackbar.text = "Unknown error occurred";
					this.snackbar.visible = true;
				}
			},

			currencyFormat(amount) {
				return Helper.currencyFormat(amount);
			},
		},
		created() {
			this.getGrnDetails();
		},
	};
</script>
